export const formatNumberForLocaleWithoutDecimals = (value: number, locale = 'de-DE'): string =>
  new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(value)
